<app-create-update-ivr-evaluation #createUpdateIvrEvaluationComponent
  [ivrEvaluation]="ivrEvaluation"
  (onChangedIvrEvaluation)="onCreatedIvrEvaluation($event)"
  ></app-create-update-ivr-evaluation>
